import React from 'react'
import { ThemeHeading } from '../../components/common/ThemeHeading'
import { SkillBox } from './skillbox'
import SkillData from '../../data/skils'

export default function Skills(props) {
    return (
        <section className="skills-wrapper site-margin wow bounceInUp" data-wow-duration="1s" data-wow-delay="0.6s"
            id="skills">
            <div className="container">
            <ThemeHeading heading="Skills and Abilities" />
                <div className="row">
                    {SkillData.map(skill => (
                        <SkillBox key={skill.id}
                        skillShape="progress-value w-100 h-100 rounded-circle d-flex align-items-center justify-content-center"
                        skillPercnt={skill.percentage} skillTitle={skill.title} skillValue={skill.value} />
                    ))}
                </div>
            </div>
        </section>
    )
}